<template>
  <i> (évite {{ avoidName }})</i>
</template>

<script>
export default {
  props: {
    members: {
      type: Array,
      required: true,
    },
    member: {
      type: Object,
      required: true,
    },
  },
  computed: {
    avoidName() {
      let result = this.members.filter((t) =>
        t.id === this.member.av ? t : null
      )[0];
      return result[Object.keys(result)[0]];
    },
  },
};
</script>